
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row alert-container-block">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Select bundles or bundle parts to reorder</p>
      </div>
    </div>
  </div>
  <div class="row card-block">
    <div class="col">
      <div class="row">Assets:</div>
      <div class="row">
        <table class="table table-responsive">
          <thead>
            <tr class="table-header-with-controls">
              <th></th>
              <th>SKU</th>
              <th>Model</th>
              <th>Serial Number</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <ng-template ngFor let-asset [ngForOf]="assets" let-i="index">
              <tr>
                <td></td>
                <td>{{ asset.productNumber }}</td>
                <td>{{ asset.productDescription }}</td>
                <td>{{ asset.serialNumber }}</td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [name]="&quot;bundleOptions&quot; + i" [(ngModel)]="asset.reorderFullBundle" autoLinkToLabel [disabled]="disableStep">
                    <label class="form-check-label">Reorder printer and all accessories</label>
                  </div>
                </td>
              </tr>
              <ng-container *ngIf="!asset.reorderFullBundle">
                <tr class="no-top-border no-top-padding" *ngFor="let part of asset.accessories">
                  <td>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="part.selected" [disabled]="disableStep">
                    </div>
                  </td>
                  <td>{{ part.productNumber }}</td>
                  <td>{{ part.productDescription }}</td>
                  <td>{{ part.serialNumber }}</td>
                  <td></td>
                </tr>
                <tr class="no-top-border no-top-padding" *ngFor="let part of asset.standaloneAccessories">
                  <td>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="part.selected" [disabled]="disableStep">
                    </div>
                  </td>
                  <td>{{ part.productNumber }}</td>
                  <td>{{ part.productDescription }}</td>
                  <td>{{ part.serialNumber }}</td>
                  <td></td>
                </tr>
              </ng-container>
            </ng-template>
            <tr *ngIf="!assets?.length">
              <td colspan="5">
                <p class="text-center empty-table-message">There are no Assets to display.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <div class="btn-group ml-1"></div>
      </div>
    </div>
  </div>
</div>